import {useEffect} from 'react';
import {observer} from 'mobx-react';
import {useIntl} from 'react-intl';
import {useToasts} from 'react-toast-notifications';
import useSocket from 'src/hooks/use-socket.js';
import useStore from 'src/hooks/use-store.js';
import {notifyReportJobMailNotice} from 'src/helpers/report.js';

/**
 * Aviso de relatório grande demais para o e-mail, em qualquer tela. O pedido novo com e-mail só descobre que o arquivo
 * passa do teto de anexo quando o worker termina, minutos depois; o aviso chega pelo evento `reportJobs` do socket, e
 * o toast de 30 s diz que o relatório está pronto para baixar em Relatórios Solicitados.
 *
 * BUSINESS RULE: o aviso aparece em qualquer tela em que a pessoa estiver, e só para quem fez o pedido: quem mais
 * recebe o evento (administrador com a notificação de relatório pronto) não pediu o e-mail. Cada pedido avisa uma vez
 * só, mesmo que o evento chegue de novo.
 *
 * Fica montado na raiz do app, ao lado do provedor de eventos, e não na lista de pedidos: a lista só existe enquanto
 * a tela de Relatórios Solicitados está aberta.
 */
const ReportJobNoticeProvider = ({children}) => {
  const {reportJobs: reportJobs$} = useSocket();
  const {store} = useStore();
  const {addToast} = useToasts();
  const intl = useIntl();
  const userId = store.auth.isLogged && store.auth.user ? store.auth.user.id : undefined;

  useEffect(() => {
    if (userId === undefined) {
      return undefined;
    }
    const subscription = reportJobs$.subscribe((jobs) => {
      (jobs || [])
          .filter((job) => job.userId === userId)
          .forEach((job) => notifyReportJobMailNotice(addToast, intl, job));
    });
    return () => subscription.unsubscribe();
  }, [reportJobs$, addToast, intl, userId]);

  return children || null;
};

export default observer(ReportJobNoticeProvider);
